import React from 'react';
import _ from 'lodash';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import IVRService from '../../../../../service/IVRService';
import IVRConversationModal from './IVRConversationModal';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import SearchBarWithCountryCodeDropdown from '../../../../searchbar/SearchBarWithCountryCodeDropdown';

class IVR extends React.Component {
  constructor(props) {
    super(props);

    this.comboFields = [
      {
        value: 'confirmationNumber',
        display: 'Confirmation Number',
      },
      {
        value: 'phoneNumber',
        display: 'Phone Number',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'transactionId',
        display: 'Transaction Id',
      },
    ];

    this.secondaryCountryCodeField = [
      {
        value: '1',
        display: 'America/Canada (+1)',
      },
      {
        value: '',
        display: 'Custom Country Code',
      },
    ];

    this.allowedConversationKeys = [
      'id',
      'externalAccountId',
      'serviceOfferingId',
      'phoneNumber',
      'confirmationNumber',
    ];

    this.state = {
      grid: null,
      isReady: false,
      selectedConversationRow: null,
      conversationRows: [],
    };
  }

  onConversationRowSelect(selectedRow) {
    const { conversationRows, } = this.state;

    const conversation = conversationRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedConversationRow: conversation.raw,
    });
  }

  getConversations(criteria, onCompletion) {
    this.reset();

    IVRService.getIVRConversationsBySearch(criteria)
      .then((response) => {
        const { conversations, } = response.data;
        const headers = this.allowedConversationKeys.map(header => ({
          value: header,
          display: _.startCase(header),
        }));
        const rows = [];

        conversations.forEach((conversation) => {
          const filtered = _.pick(conversation, this.allowedConversationKeys);

          rows.push({
            value: Object.values(filtered),
            raw: conversation,
          });
        });

        this.setState({
          grid: (
            <FieldSet title="IVR Conversations">
              <Grid
                headers={headers}
                rows={rows}
                onRowSelect={row => this.onConversationRowSelect(row)}
                onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              />
            </FieldSet>
          ),
          conversationRows: rows,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        onCompletion();
        this.setState({ isReady: true, });
      });
  }

  formatConversationDetails = (conversation) => {
    if (!conversation) {
      return null;
    }

    return (
      <div className="container">
        <hr />
        <div className="row">
          <div className="p-2">
            <IVRConversationModal conversation={conversation} />
          </div>
        </div>
      </div>
    );
  };

  formatSelectedConversationDisplay(conversation) {
    if (!conversation) {
      return null;
    }
    return <p>{`Selected conversation ID: ${conversation.id}`}</p>;
  }

  searchOnClick(event) {
    const { combo = {}, search = {}, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;
    this.getConversations(criteria, event.kill);
  }

  reset() {
    this.setState({
      grid: null,
      isReady: false,
      selectedConversationRow: null,
      conversationRows: [],
    });
  }

  showConversations() {
    const {
      isReady, grid, selectedConversationRow,
    } = this.state;

    if (isReady) {
      return (
        <>
          {grid}
          {this.formatSelectedConversationDisplay(selectedConversationRow)}
          {this.formatConversationDetails(selectedConversationRow)}
        </>
      );
    }

    return null;
  }

  showLinkForm() {
    const { linkForm, } = this.state;
    this.setState({ linkForm: !linkForm, });
  }

  render() {
    return (
      <div className="container">
        <SearchBarWithCountryCodeDropdown
          comboFields={this.comboFields}
          secondaryDropdownValues={this.secondaryCountryCodeField}
          onClick={event => this.searchOnClick(event)}
        />
        <div className="row">
          <div className="col-12">
            {this.showConversations()}
          </div>
        </div>
      </div>
    );
  }
}

export default IVR;
